export default function AuthPage({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="hidden lg:flex flex-col justify-between bg-[#7F1D1D] text-white p-12">
        <div className="w-24 h-24 rounded-2xl bg-white p-2"><img src="/img/logo.png" alt="POKYA" className="w-full h-full object-contain" /></div>
        <div>
          <h1 className="font-display text-5xl font-extrabold leading-tight">Panel Pekerja</h1>
          <p className="text-white/80 mt-3 max-w-sm">Urus pesanan, menu dan laporan POKYA RESTAURANT di satu tempat.</p>
        </div>
        <p className="text-xs text-white/60">© POKYA RESTAURANT</p>
      </div>
      <div className="flex flex-col items-center justify-center p-4 gap-6">
        <img src="/img/logo.png" alt="POKYA" className="w-24 lg:hidden" />
        {children}
      </div>
    </div>
  );
}
